var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #f89b60;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_09-warning",
    "data-name": " 09-warning"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32,32h16v16h-16v-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64,32h16v16h-16v-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96,32h16v16h-16v-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288,136h-64c-4.42,0-8,3.58-8,8,0,.38.03.76.08,1.14l16,112c.57,3.94,3.94,6.86,7.92,6.86h32c3.98,0,7.35-2.92,7.92-6.86l16-112c.63-4.37-2.41-8.43-6.78-9.05-.38-.05-.76-.08-1.14-.08h0ZM265.06,248h-18.13l-13.71-96h45.55l-13.71,96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280,280h-48c-4.42,0-8,3.58-8,8v32c0,4.42,3.58,8,8,8h48c4.42,0,8-3.58,8-8v-32c0-4.42-3.58-8-8-8ZM272,312h-32v-16h32v16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.27,173.51c-30.61,37.93-30.61,92.07,0,129.99l12.53-9.99c-25.92-32.09-25.92-77.92,0-110.01l-12.53-9.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.27,173.51c-30.61,37.93-30.61,92.07,0,129.99l12.53-9.99c-25.92-32.09-25.92-77.92,0-110.01l-12.53-9.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M335.2,183.5c25.92,32.09,25.92,77.92,0,110.01l12.5,9.99c30.61-37.93,30.61-92.07,0-129.99l-12.5,9.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M391.2,183.5c25.92,32.09,25.92,77.92,0,110.01l12.5,9.99c30.61-37.93,30.61-92.07,0-129.99l-12.5,9.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M475.58,0H36.42C16.32.02.02,16.32,0,36.42v327.15c.02,20.11,16.32,36.4,36.42,36.42h439.15c20.11-.02,36.4-16.32,36.42-36.42V36.42c-.02-20.11-16.32-36.4-36.42-36.42h0ZM475.58,384H36.42c-11.27-.02-20.41-9.15-20.42-20.42V80h400v-16H16v-27.58c.02-11.27,9.15-20.41,20.42-20.42h439.15c11.27.02,20.41,9.15,20.42,20.42v27.58h-48v16h48v283.58c-.02,11.27-9.15,20.41-20.42,20.42Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a2e6e6a34bb1a8ec55bdb462ee46ff99.svg";
export { ForwardRef as ReactComponent };